import { render, staticRenderFns } from "./addClaim.vue?vue&type=template&id=97cc10f8"
import script from "./addClaim.vue?vue&type=script&lang=js"
export * from "./addClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97cc10f8')) {
      api.createRecord('97cc10f8', component.options)
    } else {
      api.reload('97cc10f8', component.options)
    }
    module.hot.accept("./addClaim.vue?vue&type=template&id=97cc10f8", function () {
      api.rerender('97cc10f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/addClaim.vue"
export default component.exports